export function calculateTotalPages(total, pageSize) {
    return Math.ceil(total / pageSize);
}
export const getFilterTypeArray = (type) => type ? [type] : [];
export function calculateSelectedFilters(selectedFilters) {
    let total = 0;
    Object.keys(selectedFilters).forEach((selectedFilter) => {
        if (Array.isArray(selectedFilters[selectedFilter])) {
            total += selectedFilters[selectedFilter].length;
        }
        else {
            total += getFilterTypeArray(selectedFilters[selectedFilter]).length;
        }
    });
    return total;
}
//# sourceMappingURL=search-context.utils.js.map